import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useGroupChatContext } from '../../context/groupchatContext';
import { useSendMessageMutation } from '../../services/chatService';
import { FaSpinner } from 'react-icons/fa';
import { getBaseUrl } from '../../helpers/utility';
import { PageDialogContent, PageDialogFooter } from '../../components/dialog';
import { BtnComponent } from '../../components/button';
import { TextAreaField } from '../../components/reactHookFormFields/textAreaFields';
import { useForm } from 'react-hook-form';

const AutoMessageReplyWindow = React.memo(({msgId, closeHandler}) => {

    const scrollRef = useRef();
    const [isLoading, setIsLoading] = useState(false)
    const groupChatContext = useGroupChatContext();
    const {authData, selectedChat, messages, setMessages} = useMemo(() => ({
        authData: groupChatContext.authData,
        selectedChat: groupChatContext.selectedChat,
        messages: groupChatContext.messages,
        setMessages: groupChatContext.setMessages,

    }));

    const [sendMessage, {isLoading: isSendingMsg}] = useSendMessageMutation();

    const {
        handleSubmit,
        setValue,
        getValues,
        control,
        formState: { errors },
    } = useForm({});
    
    
    const streamCharacterData = () => {

        const params = [
            `tz=${new Date().getTimezoneOffset()}`,
            `practice_id=${authData.practice?.id}`,
            `new_chat=1`,
            `location_id=${selectedChat.location.uuid}`,
            `portal=provider`,
            `token=${authData.auth}`,
            `message_id=${msgId}`,
        ].join('&');

        setIsLoading(true)
        fetch(`${getBaseUrl().api_url}/nursing_home_chats/suggest_reply.json?${params}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then((response) => {
            setIsLoading(false)
            const stream = response.body;
            const reader = stream.getReader();
            // Read and process the data
            readStream(reader);
        })
        .catch((error) => {
            console.error('Error fetching data:', error);
        });
    };
    
    const readStream = (reader) => {
        reader.read().then(({ done, value }) => {
            if(done){
                if (done == true) {
                    setTimeout(() => {
                        scrollContainerToBottom();
                    }, 1000);
                }
                return;
            }
            // Process the received data chunk (convert from Uint8Array to string)
            const chunk = new TextDecoder('utf-8').decode(value);
            // stream_callback(chunk)
            readStream(reader);

            console.log("chunk: ", chunk)
            let combineChunkVal = getValues('auto_reply_box');
            if(combineChunkVal){
                combineChunkVal = `${combineChunkVal}${chunk}`
            }
            else{
                combineChunkVal = chunk
            }
            setValue('auto_reply_box', combineChunkVal)
        });
    }
   
    const scrollContainerToBottom = () => {
        setTimeout(() => {
            if (scrollRef?.current?.scrollTo) {
                const scrollHeight = scrollRef?.current?.scrollHeight;
                const height = scrollRef?.current?.clientHeight;
                const maxScrollTop = scrollHeight - height;
                scrollRef.current.scrollTo({top: maxScrollTop > 0 ? maxScrollTop : 0, behavior: "smooth"});
            }
          }, 750);
    }

    useEffect(()=>{
        if(msgId){
            scrollContainerToBottom();
            streamCharacterData();
        }
    }, [msgId])

    const sendMessageIntoChat = async (values) =>{
        const payload = {pid: selectedChat?.pid, message: { text: values.auto_reply_box, type: "message" }};
        const res = await sendMessage(payload);
        if(res?.data?.code === 0){
            setMessages({...messages, data: [res.data.data, ...messages.data]})
            closeHandler();
        }
        else {
            toast.error(res?.data?.msg);
        }
    }


    return (
        <>
            <PageDialogContent>
                <form id="auto_reply_form" onSubmit={handleSubmit(sendMessageIntoChat)}>
                    {isLoading && (
                        <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto absolute inset-0 outline-none focus:outline-none before:absolute before:flex before:w-full before:h-full z-[999]">
                            <FaSpinner className="animate-spin text-green-300-500 ml-1" size={40} />
                        </div>
                    )}
                    <div id="scrollableDiv" ref={scrollRef} className="flex flex-1 flex-col relative min-h-10 max-h-[70vh] overflow-auto px-2">
                        <TextAreaField
                            name="auto_reply_box"
                            title=""
                            rows="6"
                            control={control}
                            rules={{
                                required: {value: true},
                            }}
                            errors={errors}
                        />
                    </div>
                </form>
            </PageDialogContent>
            <PageDialogFooter>
                <BtnComponent text="Cancel" btnType="default" onClick={closeHandler} />
                <BtnComponent text="Send" btnType={authData?.is_provider ? 'primary' : 'primary_theme'} form="auto_reply_form" loading={isSendingMsg} type="submit" />
            </PageDialogFooter>
        </>
    );
});

export default AutoMessageReplyWindow;